{
  "es": {
    "modelPicker": {
      "hangarTitle": "Añadir naves a tu hangar",
      "compareTitle": "Seleccionar naves para comparar",
      "cargoGridsTitle": "Seleccionar naves para la grilla de carga",
      "wishlistTitle": "Añadir naves a tu lista de deseos",
      "labels": {
        "search": "Buscar por nombre o fabricante",
        "hangarOnly": "Solo mis naves",
        "containerFit": "Carga a transportar",
        "results": "%{count} naves",
        "selected": "%{count} seleccionadas"
      },
      "actions": {
        "resetFilters": "Restablecer filtros",
        "clearSelection": "Borrar la selección",
        "increase": "Añadir otra %{name}",
        "decrease": "Quitar una %{name}"
      },
      "badges": {
        "inHangar": "En el hangar",
        "onWishlist": "En la lista de deseos",
        "comparing": "En comparación",
        "onCargoGrid": "En la grilla"
      }
    }
  }
}
